import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import {
  ViewController,
  ToastController,
  LoadingController
} from "ionic-angular";
import { Store } from "@ngrx/store";
import { AppState } from "../../app/models/app.state";
import { TranslateService } from "@ngx-translate/core";
import { _i18n_str } from "../../assets/i18n/non-static-ids";
import { Component } from "@angular/core";
import { AuthService } from "../../app/services/auth.service";
import { patternValidator } from "../../app/validators/pattern-validator.directive";
import { minNumericCharactersValidator } from "../../app/validators/min-numeric-characters-validator.directive";
import { forbiddenSubstringValidator } from "../../app/validators/forbidden-substring-validator.directive";
import { passwordMatchValidator } from "../../app/validators/password-match-validator.directive";

// https://plonerestapi.readthedocs.io/en/latest/users.html

@Component({
  selector: "change-password-modal",
  templateUrl: "change-password.modal.html"
})
export class ChangePasswordModal {
  passwordForm: FormGroup;
  constructor(
    public viewCtrl: ViewController,
    public toastCtrl: ToastController,
    private fb: FormBuilder,
    public store: Store<AppState>,
    public loadingCtrl: LoadingController,
    public translate: TranslateService,
    public auth: AuthService
  ) {
    const names = this.auth.userState.userName.split(" ");
    const namesValidation = names.map(name =>
      forbiddenSubstringValidator(name, { hasNameInPassword: true })
    );
    this.passwordForm = this.fb.group(
      {
        curPassword: [
          null,
          Validators.compose([Validators.required, Validators.minLength(6)])
        ],
        newPassword: [
          null,
          Validators.compose([
            Validators.required,
            // Check whether the entered password has the user's name in the password
            ...namesValidation,
            forbiddenSubstringValidator(this.auth.userState.uuid, {
              hasUserNameInPassword: true
            }),
            // Check whether the entered password has at least two numbers
            minNumericCharactersValidator(2, { hasAtleastTwoNumbers: true }),
            // Check whether the entered password has upper case letter
            patternValidator(/[ÆØÅA-Z]/, { hasCapitalCase: true }),
            // Check whether the entered password has a lower-case letter
            patternValidator(/[æøåa-z]/, { hasSmallCase: true }),
            // Check whether the entered password has a minimum of 8 characters
            Validators.minLength(8)
          ])
        ],
        newPasswordDuplicate: [
          null,
          Validators.compose([Validators.required, Validators.minLength(8)])
        ]
      },
      {
        // check whether our password and confirm password match
        validator: passwordMatchValidator
      }
    );
    this.passwordForm.valueChanges.subscribe(value =>
      console.log(value, this.passwordForm)
    );
  }

  getValidationRuleIcon(controlName, rules: string[]) {
    const form = this.passwordForm;
    const control = form.get(controlName);
    if (!control.dirty || control.value === "") {
      return "";
    }
    const errors = rules.map(ruleName => {
      return control.errors !== null && control.errors.hasOwnProperty(ruleName);
    });
    const iconName = errors.includes(true)
      ? "close-circle"
      : "checkmark-circle";
    return iconName;
  }

  dismiss($event) {
    this.viewCtrl.dismiss();
  }

  submitPasswordChange($event) {
    const loading = this.loadingCtrl.create({
      content: this.translate.instant(
        _i18n_str("GENERIC_UI.CHANGING_PASSWORD")
      ),
      dismissOnPageChange: true
    });
    loading.present();
    this.auth
      .changePassword(
        this.passwordForm.controls["curPassword"].value,
        this.passwordForm.controls["newPassword"].value
      )
      .subscribe(
        result => {
          loading.dismissAll();
          this.viewCtrl.dismiss();
          const toast = this.toastCtrl.create({
            message: `Adgangskode ændret!`,
            duration: 3000,
            position: "top",
            closeButtonText: "Luk",
            showCloseButton: true
          });
          toast.present();
        },
        error => {
          this.passwordForm.controls["curPassword"].setValue("");
          loading.dismissAll();
          const toast = this.toastCtrl.create({
            message: `Din nuværende adgangskode var ikke indtastet korrekt`,
            duration: 3000,
            position: "top",
            closeButtonText: "Luk",
            showCloseButton: true
          });
          toast.present();
        }
      );
  }
}



// WEBPACK FOOTER //
// ./src/modals/change-password.modal/change-password.modal.ts